<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Templates</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <card>
            <div slot="header" class="row align-items-center">
              <div class="col-8">
                <h3 class="mb-0">Proposal Template Management</h3>
              </div>
              <div class="col-4 text-right">
                <a
                  href="javascript:"
                  class="btn btn-sm btn-primary"
                  @click="saveTemplate"
                  :disabled="!selectedType || saving"
                >
                  <i class="fa fa-save"></i> Save Template
                </a>
              </div>
            </div>

            <div v-loading="loading">
              <div class="row mb-4">
                <div class="col-lg-4">
                  <label class="form-control-label">Select Template</label>
                  <el-select
                    v-model="selectedType"
                    placeholder="Select a template"
                    class="w-100"
                    @change="onTemplateChange"
                  >
                    <el-option
                      v-for="opt in templateOptions"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                    ></el-option>
                  </el-select>
                </div>
              </div>

              <div v-if="selectedType">
                <h6 class="heading-small text-muted mb-2">Template Content</h6>
                <div v-loading="saving">
                  <html-editor
                    name="template_content"
                    :value="content"
                    @input="content = $event"
                  ></html-editor>
                </div>
              </div>

              <div v-else class="text-center text-muted py-5">
                <i class="fa fa-file-alt fa-2x mb-3"></i>
                <p>Select a template above to view and edit its content.</p>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { Notification } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import HtmlEditor from "@/components/Inputs/HtmlEditor.vue";
import { SettingsService } from "@/services";

export default {
  name: "Templates",
  components: {
    RouteBreadCrumb,
    HtmlEditor,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      loading: false,
      saving: false,
      selectedType: null,
      content: "",
      templateOptions: [
        { value: "au_proposal_venue_request", label: "AU Proposal Venue Request" },
        { value: "uk_proposal_venue_request", label: "UK Proposal Venue Request" },
      ],
    };
  },
  methods: {
    async onTemplateChange(type) {
      this.content = "";
      this.loading = true;
      try {
        const response = await SettingsService.getTemplate(type);
        this.content = response.data?.content ?? "";
      } catch (error) {
        Notification.error({
          title: "Error",
          message: "Failed to load template.",
          showClose: true,
        });
      } finally {
        this.loading = false;
      }
    },
    async saveTemplate() {
      if (!this.selectedType) return;
      this.saving = true;
      try {
        await SettingsService.saveTemplate(this.selectedType, this.content);
        Notification.success({
          title: "Saved",
          message: "Template saved successfully.",
          showClose: true,
        });
      } catch (error) {
        Notification.error({
          title: "Error",
          message: error?.response?.data?.error?.message ?? "Failed to save template.",
          showClose: true,
        });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
